export const CART_PERIOD = 'CART PERIOD';
export const CART_CURRENCY = 'CART CURRENCY';
export const CART_DOMAINS = 'CART DOMAINS';
export const CART_ACCOUNT = 'CART ACCOUNT';
export const CART_TARIFF = 'CART TARIFF';
export const CART_EXTRA = 'CART EXTRA';
export const CART_RENEW = 'CART RENEW';
export const CART_AUTO_UPGRADE = 'CART AUTO_UPGRADE';
export const CART_SAVE_PRODUCTS = 'CART SAVE PRODUCTS';
export const CART_INCLUDE_PRODUCT = 'CART INCLUDE PRODUCT';
export const FROM_QUERY = '_FROM QUERY';
export const SYNC_FEATURED_PRODUCTS = 'SYNC_FEATURED_PRODUCTS';
export const BEFORE_AUTH = '_BEFORE AUTH';
export const FEATURED = 'FEATURED';
export const CART_FLAGS = 'CART FLAGS';
export const CART_SELECTED_CUSTOM_BILLS = 'CART_SELECTED CUSTOM BILLS';
